import TopBar from "./top-bar";

export default function CategoriesContent() {
  return (
    <>
      <TopBar />
    </>
  );
}
